import { render, staticRenderFns } from "./holdApproval.vue?vue&type=template&id=8bc80c08"
import script from "./holdApproval.vue?vue&type=script&lang=js"
export * from "./holdApproval.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports